import TargetHistory from './targetHistory';
import TargetInstructions from './targetInstructions';
import TargetInformation from './targetInformation';

import { TargetProperties } from '../../../../../../redux/API/ClientAPIHelpers/programTargetsProperties';

interface TargetInfoProperties {
	id: string;
	item: TargetProperties;
	programId: string;
}

const TargetInfo = ({ id, programId, item }: TargetInfoProperties) => (
	<div className="targetInfoContainer">
		<TargetInformation item={item} />
		<TargetInstructions data={item} id={id} programId={programId} />
		<TargetHistory id={id} programId={programId} />
	</div>
);

export default TargetInfo;
